import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="uxpmenuitems" id="uxpmenuitems"></a>
    <h1 {...{
      "id": "uxpmenuitems"
    }}>{`UxpMenuItems`}</h1>
    <p>{`Class describing the menu of a panel.`}</p>
    <a name="uxpmenuitems-size" id="uxpmenuitems-size"></a>
    <h2 {...{
      "id": "size--number"
    }}>{`size ⇒ `}<inlineCode parentName="h2">{`Number`}</inlineCode></h2>
    <p>{`Get number of menu items`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Number`}</inlineCode>{`  `}</p>
    <a name="uxpmenuitems-getitem" id="uxpmenuitems-getitem"></a>
    <h2 {...{
      "id": "getitemid"
    }}>{`getItem(id)`}</h2>
    <p>{`Get menu item with specified id`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`UxpMenuItem`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="uxpmenuitems-getitemat" id="uxpmenuitems-getitemat"></a>
    <h2 {...{
      "id": "getitematindex"
    }}>{`getItemAt(index)`}</h2>
    <p>{`Get menu item at specified index`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`UxpMenuItem`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`index`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Number`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="uxpmenuitems-insertat" id="uxpmenuitems-insertat"></a>
    <h2 {...{
      "id": "insertatindex-newitem"
    }}>{`insertAt(index, newItem)`}</h2>
    <p>{`Inserts/replaces the menu item at the specified index with the new menu item.
index < size of menuItems array : replaces the existing menu item
index = size of menuItems array : Inserts menu item at end
index > size of menuItems array : throws invalid index exception`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`index`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`newItem`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`see 'entrypoints.setup' api for menu item description.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="uxpmenuitems-removeat" id="uxpmenuitems-removeat"></a>
    <h2 {...{
      "id": "removeatindex"
    }}>{`removeAt(index)`}</h2>
    <p>{`Removes menu item from specified index.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`index`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Number`}</inlineCode></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      